<template>
  <tool-panel>
    <template v-slot:title>Template Tools</template>
    <tool-link
      external
      :to="docAdminUrl"
      icon="fa-home"
      label="Document Admin"
    ></tool-link>
    <tool-link
      v-if="!templateLinked"
      to="/templates"
      icon="fa-plus"
      label="Associate this document with a sharedo template"
    ></tool-link>
    <tool-link
      v-if="templateLinked"
      to="/templates"
      icon="fa-file-contract"
      label="Template Details - Manage template details"
    ></tool-link>
    <tool-link
      v-if="capabilities.separateContentBlocks"
      :to="contentBlocksRoute"
      icon="fa-file-code"
      label="Content Blocks"
    />
    <tool-link
      to="/document-browser"
      icon="fa-file-invoice"
      label="Explorer - Explore template controls"
    ></tool-link>
    <tool-link
      v-if="templateLinked"
      to="/tags"
      icon="fa-tags"
      label="Tag Browser - Find dynamic content"
    ></tool-link>
    <tool-link
      v-if="templateLinked"
      to="/businessrules"
      icon="fa-code-branch"
      label="Display Rules - Define business rules"
    ></tool-link>
    <tool-link
      v-if="templateLinked"
      to="/sections"
      icon="fa-puzzle-piece"
      label="Sections - Define dynamic sections"
    ></tool-link>
  </tool-panel>
</template>
<script>
import currentTempates from "@/mixins/currentTemplates";
import ToolPanel from "./ToolPanel.vue";
import ToolLink from "./ToolLink.vue";
import sharedoSettings from "@/services/sharedo/sharedoSettingsService";
import { FOR_TEMPLATE_AUTHORS } from "@/constants/contentBlockIncludes";

export default {
  components: { ToolPanel, ToolLink },
  mixins: [currentTempates],
  computed: {
    templateLinked: function() {
      return this.currentTemplates.length > 0;
    },
    docAdminUrl: function() {
      const settings = sharedoSettings.get();
      return `${settings.sharedoApi}/admin-documents`;
    },
    contentBlocksRoute: function () {
      return {
        name: "ContentBlocks",
        params: { include: FOR_TEMPLATE_AUTHORS },
      };
    },
  },
};
</script>
